
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/goautowarranty/privacy-policy",
      function () {
        return require("private-next-pages/goautowarranty/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/goautowarranty/privacy-policy"])
      });
    }
  